export enum GigJobStages {
  IN_PROGRESS = 1,
  PAYED = 2,
  RETURNED = 3,
  BLOCKED = 4,
  DISPUTED = 5,
}
